export const convertTimeDataToDescription = (time) => time.toLocaleString('en-US', { hour: '2-digit', minute: 'numeric', hour12: true })
